import React from 'react';
import classNames from 'classnames';
import { Button, Dropdown } from '@nackle/paper';
import Help from '../help/help.js';
import './label-container.less';
export default class LabelContainer extends React.Component {
  render() {
    const {
      children,
      className,
      helpText,
      actionLabel,
      actionDisabled,
      actionMenu,
      actionMenuVisible,
      onActionMenuVisibleChange,
      onActionClick,
      style
    } = this.props;
    return /*#__PURE__*/React.createElement("span", {
      className: classNames('label-container', className),
      style: style
    }, children, helpText && /*#__PURE__*/React.createElement(Help, {
      text: helpText
    }), actionLabel && !actionMenu && /*#__PURE__*/React.createElement(Button, {
      className: "label-action",
      type: "link",
      size: "small",
      disabled: actionDisabled,
      onClick: onActionClick
    }, actionLabel), actionLabel && actionMenu && /*#__PURE__*/React.createElement(Dropdown, {
      trigger: ['click'],
      visible: actionMenuVisible,
      onVisibleChange: onActionMenuVisibleChange,
      overlay: actionMenu
    }, /*#__PURE__*/React.createElement(Button, {
      className: "label-action",
      type: "link",
      size: "small",
      disabled: actionDisabled,
      onClick: onActionClick
    }, actionLabel)));
  }
}
//# sourceMappingURL=label-container.js.map